module.exports = __webpack_public_path__ + "static/media/ArchiveIcon.6d383886.svg";